import { Icon } from '../ui/Icon';
import { useNavigation } from '../../hooks/useNavigation';

export default function CTA() {
  const { goTo } = useNavigation();

  return (
    <section className="relative py-24 px-6 overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto relative">
        <div className="relative rounded-[3rem] bg-gray-900 overflow-hidden px-6 py-20 md:px-16 md:py-24 text-center">

          {/* Background Effects */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-orange-500/20 rounded-full blur-[120px] pointer-events-none" />
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-500/10 rounded-full blur-[80px] pointer-events-none" />

          {/* Content */}
          <div className="relative z-10 max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-md mb-8">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
              <span className="text-sm font-medium text-white">Accepting New Partners</span>
            </div>

            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-8">
              Ready to Scale Your <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">Global Operations?</span>
            </h2>

            <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto leading-relaxed">
              Join a network of global businesses leveraging EasyBuy General Trading for seamless, reliable, and efficient trading solutions.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => goTo('/contact')}
                className="w-full sm:w-auto px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-xl shadow-orange-500/25 flex items-center justify-center gap-2"
              >
                Start Trading Now
                <Icon name="arrow-right" className="w-5 h-5" />
              </button>
            </div>

            <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap justify-center gap-x-12 gap-y-6">
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-white">50+</span>
                <span className="text-gray-500 text-sm uppercase tracking-wider">Countries</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-white">10k+</span>
                <span className="text-gray-500 text-sm uppercase tracking-wider">Shipments</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-3xl font-bold text-white">24/7</span>
                <span className="text-gray-500 text-sm uppercase tracking-wider">Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
